var MissingDeviceConfigurationService = (function () {
    function MissingDeviceConfigurationService($http) {
        this.$http = $http;
    }
    MissingDeviceConfigurationService.prototype.get = function () {
        var url = 'compatibilityguide/ng-settings/feature/forms/missingdevice';
        return this.$http
            .get(url)
            .then(function (response) {
            return response.data;
        });
    };
    MissingDeviceConfigurationService.$inject = ['$http'];
    return MissingDeviceConfigurationService;
}());
export { MissingDeviceConfigurationService };
